import {
  ArrayPath,
  FieldArray,
  FieldValues,
  Path,
  useFieldArray,
  useFormContext,
} from 'react-hook-form';

export const useFormArray = <
  FormContext extends FieldValues,
  FieldName extends ArrayPath<FormContext> & Path<FormContext> = ArrayPath<FormContext> &
    Path<FormContext>,
>(
  fieldName: FieldName,
  defaultNewValue: FieldArray<FormContext, FieldName>
) => {
  const { control, watch } = useFormContext<FormContext>();
  const { fields, append, insert, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const addElement = (index: number, override?: FieldArray<FormContext, FieldName>) => {
    insert(index + 1, override || defaultNewValue);
  };

  const appendElement = (override?: FieldArray<FormContext, FieldName>) => {
    append(override || defaultNewValue);
  };

  const deleteElement = (index: number) => {
    remove(index);
  };

  const arrayValue: FieldArray<FormContext, FieldName>[] = watch(fieldName) || [];

  return {
    fields,
    addElement,
    deleteElement,
    appendElement,
    arrayValue,
  };
};
